import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Stack, Typography, CircularProgress, Link} from 'views/components';
import {SentimentDissatisfiedOutlined} from 'views/icons';
import {Translate} from 'views/module';

import {loginWithToken} from 'utils/auth/magic_link';

const MagicLinkReceiveBox = (props) => {
  const {
    token,

    userReload,
    statusClear,
  } = props;

  const [hasError, setHasError] = React.useState(false);

  React.useEffect(() => {
    const login = async () => {
      try {
        await loginWithToken(token);
        userReload();
        statusClear();
      } catch (e) {
        console.error(e);
        setHasError(true);
      }
    };
    setHasError(false);
    login();
  }, [token]);

  if (!hasError) {
    return (
      <Stack
        alignItems="center"
        spacing={{xs: 2, sm: 4}}
      >
        <CircularProgress
          sx={{
            size: {xs: 32, sm: 48},
          }}
        />
        <Stack spacing={1} alignItems="center">
          <Typography variant="h4" fontWeight="normal" align="center" color="text.primary">
            <Translate expression='auth.MagicLink.LoggingIn' />
          </Typography>
          <Typography variant="body1" color="text.primary" align="center">
            <Translate expression='auth.MagicLink.LoggingInSubtitle' />
          </Typography>
        </Stack>
      </Stack>
    );
  } else {
    return (
      <Stack
        alignItems="center"
        spacing={{xs: 2, sm: 4}}
      >
        <SentimentDissatisfiedOutlined
          sx={{
            height: {
              xs: 36, sm: 52,
            },
            width: {
              xs: 36, sm: 52,
            },
            color: 'text.contrast',
          }}
        />
        <Stack spacing={1} alignItems="center">
          <Typography variant="h4" fontWeight="normal" align="center" color="text.primary">
            <Translate expression='auth.MagicLink.LoginFailed' />
          </Typography>
          <Stack direction={{sm: 'column', md: 'row'}} spacing={0.5} alignItems="center">
            <Typography
              variant="body1"
              sx={{
                color: 'text.secondary',
              }}
            >
              <Translate expression='auth.MagicLink.LoginFailedSubtitle' />
            </Typography>
            <Link
              variant="body1"
              href='/'
              sx={{
                cursor: 'pointer',
              }}
            >
              <Translate expression='auth.MagicLink.LoginFailedLink' />
            </Link>
          </Stack>
        </Stack>
      </Stack>
    );
  }
};

MagicLinkReceiveBox.propTypes = {
  token: PropTypes.string.isRequired,
  userReload: PropTypes.func.isRequired,
  statusClear: PropTypes.func.isRequired,
};

const mapStateToProps = () => ({ });
export default connect(mapStateToProps, dispatch)(React.memo(MagicLinkReceiveBox));
